import { GOOGLE_PLACE_ID, REVIEW_PLATFORMS } from '@shared/ui/sd-reviews-teaser/reviews.config';

/** Öffentliche Kontaktadresse — identisch mit Footer, llms.txt und Impressum. */
export const ORGANIZATION_EMAIL = 'studio@simudrom.at';

/** Öffentliche Telefonnummer — identisch mit LocalBusiness-Schema und llms.txt. */
export const ORGANIZATION_PHONE = '+43 1 7342397';

/**
 * Profile, die SIMUDROM als Entität repräsentieren (`sameAs` im LocalBusiness-Schema).
 * KI-Suchen und Knowledge-Graphen verknüpfen darüber Website, Bewertungen und Social-Profile.
 */
export const ORGANIZATION_SAME_AS: readonly string[] = [
    'https://www.instagram.com/simudrom.at/',
    'https://linktr.ee/simudrom',
    // Null-sicher statt `!`: fällt die Profil-URL in reviews.config.ts weg, fehlt nur dieser
    // Eintrag — ein `undefined` in sameAs macht sonst das ganze JSON-LD ungültig.
    ...(REVIEW_PLATFORMS.tripadvisor.profileUrl ? [REVIEW_PLATFORMS.tripadvisor.profileUrl.en] : []),
    `https://www.google.com/maps/place/?q=place_id:${GOOGLE_PLACE_ID}`,
];

/** Postanschrift — geteilte Quelle für alle schema.org-`PostalAddress`-Blöcke (LocalBusiness, Event-Location). */
export const ORGANIZATION_ADDRESS = {
    '@type': 'PostalAddress',
    streetAddress: 'Brigittagasse 16',
    postalCode: '1200',
    addressLocality: 'Wien',
    addressCountry: 'AT',
} as const;

/** Veranstaltungsort — geteilte Quelle für `location` in Event-JSON-LD (Event-Übersicht, Event-Detail). */
export const ORGANIZATION_PLACE = {
    '@type': 'Place',
    name: 'SIMUDROM',
    address: ORGANIZATION_ADDRESS,
} as const;

/** Veranstalter — geteilte Quelle für `organizer` in Event-JSON-LD (Event-Übersicht, Event-Detail). */
export const ORGANIZATION_ORGANIZER = {
    '@type': 'Organization',
    name: 'SIMUDROM',
    url: 'https://simudrom.at',
} as const;
